import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonDivider from "../../common/components/divider/CommonDivider";
import { vitalSignsEcgData } from "./data/vitalSignsEcgData";
import BlinkingDotWithRing from "./AnimatingDot";
import { getMonitorData } from "../PatientMonitoringServices";
// import { playNotificationSound } from "../../common/components/Notify/Notifications/playNotificationSound";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ICUDIDashboardModal from "../../nursingStation/components/dipatients/didashboard/ICUDIDashboardModal";
import soundOne from "../../common/components/Notify/Sounds/soundOne.mp3";
import { Box, Modal } from "@mui/material";
import CancelPresentationIconButton from "../../common/components/Buttons/CancelPresentationIconButton";
import { CloseIcon } from "../../assets/icons/CustomIcons";
import CommonButton from "../../common/components/Buttons/CommonButton";
import AttentionModal from "./AttentionModal";

const monitor = [
  {
    bedno: "402",
    admissionid: 1072105,
    mean: 119,
    patientid: 372802,
    bp: "176/91",
    qsofa: 0,
    mews: 0,
    vpc: 0,
    patientname: "Mr. NARAYAN KSHETRI",
    respiration: 25,
    apache: 0,
    spo2val: 95,
    gcs: 0,
    temperature: 0,
    pulserate: 112,
    heartrate: 112,
    heartratealert: "Critical",
    expectedInterval: 15,
    lastAckTime: 20,
  },
  {
    bedno: "403",
    admissionid: 1072235,
    pulserate: 128,
    qsofa: 0,
    patientname: "Mr. BHUSHANLAL SHARMA",
    mews: 0,
    vpc: 0,
    respiration: 26,
    spo2val: 79,
    spo2valAlert: "High Risk",
    apache: 0,
    mean: 67,
    gcs: 0,
    bp: "80/61",
    temperature: 0,
    patientid: 6558,
    heartrate: 96,
    expectedInterval: 15,
    lastAckTime: 15,
  },
  {
    spo2val: null,
    pulserate: null,
    heartrate: null,
    qsofa: 0,
    mews: 0,
    vpc: null,
    respiration: null,
    bedno: "405",
    admissionid: 1072027,
    apache: 0,
    mean: 98,
    patientname: "Mr. MADHUKAR KADAM ",
    gcs: 0,
    patientid: 372567,
    temperature: 0,
    bp: "118/89",
    bpAlert: "Warning",
    expectedInterval: 15,
    lastAckTime: 0,
  },
  {
    spo2val: null,
    patientname: "Mr. GOPAL CHAUDHARI",
    pulserate: null,
    mean: 51,
    qsofa: 0,
    bedno: "406(ISL)",
    mews: 0,
    vpc: 0,
    heartrate: 58,
    admissionid: 1072229,
    patientid: 350129,
    apache: 0,
    gcs: 0,
    temperature: 0,
    respiration: 19,
    respirationAlert: "Critical",
    bp: "80/37",
  },
  {
    patientid: 373025,
    qsofa: 0,
    mews: 0,
    vpc: 0,
    vpcAlert: "High Risk",
    mean: 95,
    patientname: "Mrs. HASINA PATHAN",
    bp: "126/80",
    bedno: "407",
    apache: 0,
    gcs: 0,
    admissionid: 1072191,
    spo2val: 100,
    temperature: 0,
    heartrate: 112,
    respiration: 23,
    pulserate: 111,
  },
  {
    respiration: 15,
    bp: "146/62",
    qsofa: 0,
    qsofaAlert: "Warning",
    mews: 0,
    patientname: "Mr. CHANDRAKANT KALE",
    vpc: 0,
    admissionid: 1072098,
    bedno: "409",
    mean: 90,
    pulserate: 84,
    heartrate: 84,
    apache: 0,
    patientid: 329972,
    spo2val: 95,
    gcs: 0,
    temperature: 0,
  },
  {
    spo2val: null,
    bedno: "410",
    pulserate: null,
    qsofa: 0,
    heartrate: 34,
    mews: 0,
    mewsAlert: "Critical",
    bp: "45/27",
    vpc: 0,
    admissionid: 1072185,
    patientid: 360946,
    apache: 0,
    patientname: "Mr. MUNWAR KHAN",
    gcs: 0,
    mean: 33,
    temperature: 0,
    respiration: 23,
  },
  {
    bedno: "502",
    mean: 82,
    qsofa: 0,
    bp: "105/71",
    mews: 0,
    vpc: 0,
    patientname: "Mr. GANESH KATKE",
    apache: 0,
    gcs: 0,
    gcsAlert: "High Risk",
    respiration: 18,
    temperature: 0,
    spo2val: 99,
    heartrate: 105,
    patientid: 373149,
    admissionid: 1072246,
    pulserate: 108,
  },
  {
    patientname: "Mr. PRAKASH SHAH",
    qsofa: 0,
    mean: 81,
    mews: 0,
    bedno: "504",
    bp: "100/72",
    vpc: 7,
    apache: 0,
    patientid: 61011,
    gcs: 0,
    temperature: 0,
    spo2val: 99,
    admissionid: 1072178,
    respiration: 22,
    pulserate: 96,
    heartrate: 96,
  },
  {
    bp: "91/64",
    spo2val: null,
    patientid: 373154,
    pulserate: null,
    heartrate: null,
    qsofa: 0,
    mews: 0,
    vpc: null,
    bedno: "507",
    respiration: null,
    admissionid: 1072251,
    apache: 0,
    gcs: 0,
    patientname: "Mr. RAVINDRA JISWAR",
    temperature: 0,
    mean: 73,
  },
  {
    spo2val: null,
    pulserate: null,
    heartrate: null,
    qsofa: 0,
    mews: 0,
    vpc: null,
    respiration: null,
    bp: "124/90",
    bedno: "HDU1",
    mean: 101,
    apache: 0,
    gcs: 0,
    patientid: 373047,
    admissionid: 1072208,
    temperature: 0,
    patientname: "Mr. ASGAR SAYYED",
  },
];

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  minHeight: "100%",
  bgcolor: "background.paper",
  border: "1px solid gray",
  borderRadius: 1,
  overflowY: "scroll",
  boxShadow: 20,
  p: 2,
};

const ICUMonitoringChart_v1 = () => {
  const [beds, setBeds] = useState(monitor);
  const [openDIDashboardModal, setOpenDIDashboardModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showChart, setShowChart] = React.useState(true);
  const [timer, setTimer] = React.useState(0);
  const [chartData, setChartData] = React.useState([]);
  const [alertCount, setAlertCount] = React.useState(0);
  const [openAttention,setOpenAttention]=React.useState(false);
  const [selectedBed,setSelectedBed]=React.useState(null)

  const handleCLoseAttention=()=>{
      setOpenAttention(false);
  }

  const getIcuMonitorData = useCallback(() => {
    getMonitorData()
      .then((response) => response.data)
      .then((res) => {
        setBeds(res?.result);
        // setBeds(monitor);
      })
      .catch((error) => error.message);
  }, []);

  React.useEffect(() => {
    getMonitorData()
      .then((response) => response.data)
      .then((res) => {
        setBeds(res?.result);
        // setBeds(monitor);
      })
      .catch((error) => error.message);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      getIcuMonitorData();
    }, 60000);
    //60000
    return () => clearInterval(intervalId);
  }, [getIcuMonitorData]);

  // const playSound = () => {
  //   playNotificationSound();
  // };

  const playNotificationSound = () => {
    const audio = new Audio(soundOne);

    audio.volume = 1; // 0.0 to 1.0

    audio.play().catch((err) => {
      // Autoplay blocked until user interacts
      console.warn("Sound play blocked:", err);
    });
  };

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => {
    if (alertCount > 0) {
      playNotificationSound();
    }
  }, [alertCount]);

  const isCriticalOrHigh = (value) => {
    if (
      (value?.spoalert?.toLowerCase() === "critical" &&
        value?.spo2mute === false) ||
      (value?.heartratealert?.toLowerCase() === "critical" &&
        value?.heartratemute === false) ||
      (value?.bpalert?.toLowerCase() === "critical" &&
        value?.bpmute === false) ||
      (value?.respalert?.toLowerCase() === "critical" &&
        value?.respirationmute === false) ||
      (value?.spoalert?.toLowerCase() === "high" &&
        value?.spo2mute === false) ||
      (value?.heartratealert?.toLowerCase() === "high" &&
        value?.heartratemute === false) ||
      (value?.bpalert?.toLowerCase() === "high" && value?.bpmute === false) ||
      (value?.respirationalert?.toLowerCase() === "high" &&
        value?.respirationmute === false)
      //  && value?.attend === true
    ) {
      return true;
    } else return false;
  };

  React.useEffect(() => {
    if (beds?.length > 0) {
      for (let bed of beds) {
        console.log("The patient is Critical :", isCriticalOrHigh(bed), bed);

        if (isCriticalOrHigh(bed) === true) {
          setAlertCount(alertCount + 1);
        }
      }
    }
  }, [beds]);
  console.log("The selected patient for attention :",selectedBed);

  const handleOpenAttention=(bed)=>{

    
    setSelectedBed(bed);
    setOpenAttention(true);
  }

  return (
    <>
      <Modal
        open={showChart}
        onClose={() => {
          setShowChart(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle} className="max-h-[88%] xl:max-h-[80%]">
          <div className=" w-full ">
            <div className="">
              <div className="grid grid-cols-3 gap-2 items-center mb-2">
                <div></div>
                <div className="text-center font-semibold text-lg 2xl:text-xl mb-2">
                  ICU Chart
                </div>
                <div className="flex justify-end gap-3 items-center">
                  <button
                    type="button"
                    className="h-6 w-6 rounded bg-customBlue text-white"
                    onClick={() => {
                      // playSound();
                    }}
                  >
                    <NotificationsActiveIcon />
                  </button>
                  <button
                    className="mt-1"
                    type="button"
                    onClick={() => {
                      setShowChart(false);
                    }}
                  >
                    <CloseIcon />
                  </button>
                </div>
              </div>
              {beds?.length > 0 ? (
                <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-2 cursor-pointer ">
                  {beds.map((bed, index) => (
                    <BedCard
                      handleOpenAttention={handleOpenAttention}
                      i={index}
                      key={index}
                      bed={bed}
                      setOpenDIDashboardModal={setOpenDIDashboardModal}
                      setSelectedRow={setSelectedRow}
                    />
                  ))}
                </div>
              ) : (
                <p className="py-28 2xl:py-40 text-center text-gray-600 font-semibold">
                  Data Not Found...
                </p>
              )}
            </div>
          </div>
          {selectedBed !== null && (
            <AttentionModal
              selectedBed={selectedBed}
              open={openAttention}
              close={handleCLoseAttention}
              setOpenAttention={setOpenAttention}
            />
          )}
        </Box>
      </Modal>
      {openDIDashboardModal && (
        <ICUDIDashboardModal
          open={openDIDashboardModal}
          handleClose={() => setOpenDIDashboardModal(false)}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
      )}
    </>
  );
};

const BedCard = ({
  i,
  bed,
  setOpenDIDashboardModal,
  setSelectedRow,
  handleOpenAttention,
}) => {
  const alertAnimation = (type, defaultColor) => {
    var animationClass = "";

    if (
      type !== undefined &&
      type !== null &&
      type !== "" &&
      (type?.toLowerCase() === "critical" || type?.toLowerCase() === "high")
    ) {
      animationClass = "animate-pump-scale origin-center inline-block";
    }

    var colorClass = defaultColor;

    if (type?.toLowerCase() === "critical") {
      colorClass = "text-red-600";
    } else if (type?.toLowerCase() === "high") {
      colorClass = "text-orange-500";
    } else if (type?.toLowerCase() === "warning") {
      colorClass = "text-yellow-300";
    }

    return (animationClass + " " + colorClass).trim();
  };

  return (
    <div
      className=" px-2 pb-2"
      onDoubleClick={() => {
        setOpenDIDashboardModal(true);
        setSelectedRow(bed);
      }}
    >
      <div className="bg-black text-white rounded-lg w-full">
        <div className="whitespace-nowrap">
          <div className="flex justify-between items-center p-2 text-[14px]">
            <p
              className="font-semibold text-lg"
              onClick={() => {
                handleOpenAttention(bed);
              }}
            >
              {bed.patientname}
            </p>
            <p className="font-semibold">
              Bed No : {bed.bedno}
              {/* , {bed.name} */}
            </p>

            {/* <div className="flex gap-2 items-center">
              <div>
                {criticalValues?.includes(i) ? <BlinkingDotWithRing /> : ""}
              </div>
              <p
                className={`${
                  i === 3 || i === 4 || i === 5
                    ? `bg-[#f2b35a]`
                    : i === 6 || i === 7 || i === 8
                    ? `bg-[#368505]`
                    : `bg-[#ED0A0A] `
                } px-3 py-1 rounded font-medium flex items-center space-x-1`}
              >
                <span>
                  {criticalValues?.includes(i) ? <WarningAmberIcon /> : ""}
                </span>
                <span>{`${
                  i === 3 || i === 4 || i === 5
                    ? `Moderate`
                    : i === 6 || i === 7 || i === 8
                    ? `Normal`
                    : `Crirical`
                }`}</span>
              </p>
            </div> */}
          </div>
          <CommonDivider color="#7A7A7A" />
          <div className="grid grid-cols-3 items-center text-center">
            <div className="text-[13px] w-full border-b border-r border-gray-700 px-2 pb-3">
              <div
                // className={`${
                //   bed?.heartrateAlert !== "" &&
                //   bed?.heartrateAlert !== undefined &&
                //   "animate-pump-scale origin-center inline-block"
                // } ${
                //   bed?.heartrateAlert === "Critical"
                //     ? "text-red-600"
                //     : bed?.heartrateAlert === "High Risk"
                //     ? "text-orange-500"
                //     : bed?.heartrateAlert === "Warning"
                //     ? "text-yellow-300"
                //     : "text-[#00f8f8]"
                // }`}
                className={alertAnimation(
                  bed?.heartratealert,
                  "text-[#00f8f8]",
                )}
              >
                <p className="font-semibold">Heart Rate (bpm)</p>
                <h4 className={`text-[25px]`}>
                  {bed.heartrate ? bed.heartrate : "--"}
                </h4>
              </div>
            </div>
            <div className="font-semibold text-[13px] border-b border-r border-gray-700 pl-[13px] w-full pb-3">
              <div className={alertAnimation(bed?.spoalert, "text-[#fa57fa]")}>
                <p>SpO2 (%)</p>
                <h4 className="text-[25px]">
                  {bed.spo2val ? bed.spo2val : "--"}
                </h4>
              </div>
            </div>
            <div className="font-semibold w-full border-b border-gray-700 pb-3 pl-3">
              <div className={alertAnimation(bed?.bpalert, "text-[#23c4f9]")}>
                <p className="text-[13px]">NIBP (mmHg)</p>
                <h4 className="text-[25px]">{bed.bp ? bed.bp : "--"}</h4>
              </div>
            </div>
            {/* <div className="font-semibold text-[#8000FF] w-full border-b border-r border-gray-700 pl-3">
              <p className="text-[13px]">MEAN (mmHg)</p>
              <h4 className="text-[20px]">{bed.mean}</h4>
            </div> */}
          </div>
          <div className="grid grid-cols-2 items-center text-center">
            <div className="font-semibold border-b border-r border-gray-700 pl-3">
              <div className={alertAnimation(bed?.respalert, "text-[#008CFF]")}>
                <h4 className="text-[13px]">RESP (bpm)</h4>
                <h4 className="text-[20px]">
                  {bed.respiration ? bed.respiration : "--"}
                </h4>
              </div>
            </div>
            <div className="font-semibold border-b border-gray-700 pl-3">
              <div className={alertAnimation(bed?.vpcalert, "text-[#7777fa]")}>
                <h4 className="text-[13px]">VPC (Per/Min)</h4>
                <h4 className="text-[20px]">{bed.vpc ? bed.vpc : "--"}</h4>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-3  items-center text-center">
            {/* <div className="text-[#66FFCC] font-semibold  pl-3 ">
              <h4 className="text-[13px] mt-2">TEMP (°F)</h4>
              <h4 className="text-lg">{bed.temperature}</h4>
            </div> */}
            <div className="font-semibold border-gray-700 pl-3 ">
              <div
                className={alertAnimation(bed?.qsofaalert, "text-[#f363b0]")}
              >
                <h4 className="text-[13px] mt-2">qSOFA</h4>
                <h4 className="text-lg">{bed.qsofa ? bed.qsofa : "--"}</h4>
              </div>
            </div>
            <div className="font-semibold border-l border-gray-700 pl-3">
              <div className={alertAnimation(bed?.mewsalert, "text-[#a654f8]")}>
                <h4 className="text-[13px] mt-2">MEWS</h4>
                <h4 className="text-lg">{bed.mews ? bed.mews : "--"}</h4>
              </div>
            </div>
            <div className="text-[#b3cce6] font-semibold border-l border-gray-700 w-full pl-3.5">
              <div className={alertAnimation(bed?.gcsalert, "text-[#b3cce6]")}>
                <h4 className="pr-5 text-[13px] mt-2">GCS</h4>
                <h4 className="pr-5 text-lg">{bed.gcs ? bed.gcs : "--"}</h4>
              </div>
            </div>
            {/* <div className="text-[#00FC00] font-semibold border-l border-gray-700 w-full pl-2">
              <h4 className="text-[13px] mt-2">APACHE</h4>
              <h4 className="text-lg">{bed.apache}</h4>
            </div> */}
          </div>
          <div className="">
            {/* {bed?.lastAckTime !== undefined &&
            bed?.expectedInterval !== undefined &&
            bed?.lastAckTime > 0 &&
            bed?.lastAckTime >= bed?.expectedInterval &&
            Object?.values(bed)?.some(
              (val) => val === ("Critical" || "High" || "Warning"),
            ) ? (
              <label className="flex justify-center items-center font-semibold cursor-pointer animate-pulse bg-[#f70101] text-[#FFFFFF] py-1 rounded-br-lg rounded-bl-lg ">
                Attention Required
              </label>
            ) : (
              <></>
            )} */}
            {bed?.spoalert?.toLowerCase() === "critical" ||
            bed?.heartratealert?.toLowerCase() === "critical" ||
            bed?.bpalert?.toLowerCase() === "critical" ||
            bed?.respalert?.toLowerCase() === "critical" ||
            bed?.spoalert?.toLowerCase() === "high" ||
            bed?.heartratealert?.toLowerCase() === "high" ||
            bed?.bpalert?.toLowerCase() === "high" ||
            bed?.respalert?.toLowerCase() === "high" ? (
              // && bed?.attend === true
              <label className="flex justify-center items-center font-semibold cursor-pointer animate-pulse bg-[#f70101] text-[#FFFFFF] py-1 rounded-br-lg rounded-bl-lg ">
                Attention Required
              </label>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ICUMonitoringChart_v1;
